import { MdPhoneIphone, MdHome } from 'react-icons/md';
import { FaRegEnvelope } from 'react-icons/fa';

import { Container, Content } from './styles';

function Footer() {
  return (
    <Container>
      <Content>
        <div className="footer-address">
          <ul>
            <li>
              <MdPhoneIphone />
              <span>(021) 2730-6525</span>
            </li>
            <li>
              <FaRegEnvelope />
              <span>atendimento@oabrj.org.br</span>
            </li>
            <li>
              <MdHome />
              <span>
                Av. Marechal Câmara, 150 - Rio de Janeiro - RJ - CEP: 20020-080
              </span>
            </li>
          </ul>
        </div>
        <div className="footer-copy">
          OAB/RJ online - Todos os direitos reservados
        </div>
      </Content>
    </Container>
  );
}

export default Footer;
